import Card, { OnHover } from "./card.js";
import CardGroup from "./card-group.js";
Card.OnHover = OnHover;
Card.Group = CardGroup;
export default Card;
//# sourceMappingURL=index.js.map